const styles = theme => ({
    infoPanel: {
        paddingTop: '80px',
        position: 'absolute',
        width: '284px',
        right: '0%',
        height: '75%',
        display: 'inline-block',
        backgroundColor: '#000000',
        zIndex: 900,
    },
    info: {
        cursor: 'pointer',
        position: 'absolute',
        right: '3%',
        top: '7%',
        zIndex: 1000,
        '@media screen and (max-width : 1200px)': { display: 'none' },
    },

    instagram: {
        display: 'inline-block',
        color: '#FFFFFF',
        fontSize: '14px',
        fontWeight: 300,
        fontFamily: theme.typography.fontFamily,
        position: 'relative',
        left: '15px',
        height: '100%',
    },
    instagramTitle: {
        position: 'relative',
        bottom: '7px',
        left: '10px',
    },

    instagramDescription: {
        marginTop: '10px',
        width: '90%',
        height: 'calc(100% - 45px)',
        overflowY: 'auto',
    },

    description: {
        padding: '0 15px',
        color: '#FFFFFF',
        fontSize: '14px',
        fontWeight: 300,
        lineHeight: '22px',
        left: '24px',
        height: '80%',
        overflowY: 'auto',
        fontFamily: theme.typography.fontFamily,
        wordBreak: 'break-word',
    },

    viewer: {
        width: '100%',
        height: ' calc(100% - 175px)',
        '@media screen and (max-width: 768px)': {
            height: ' calc(100% - 279px)',
        },
        display: 'flex',
        overflow: 'hidden',
        justifyContent: 'center',
        position: 'relative',
        background: '#000000',
    },

    imgContainer: {
        height: '100%',
        position: 'relative',
        display: 'inline-block',
        '@media screen and (max-width : 1200px)': {
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
        },
        '@media screen and (max-width : 767px) and (orientation: landscape)': {
            height: '100%',
            width: '50%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-start',
        },
    },

    img: {
        width: 'auto',
        height: '100%',
    },
    imgText: {
        position: 'absolute',
        bottom: '5%',
        left: '24px',
        width: '540px',
        color: '#FFFFFF',
        fontFamily: theme.typography.fontFamily,
        fontSize: '36px',
        fontWeight: '500',
        lineHeight: '46px',
        zIndex: '10',
        textShadow: '2px 2px 2px rgba(0,0,0,0.5)',
    },
    imgTitle: {
        '@media screen and (max-width : 1200px)': {
            position: 'absolute',
            bottom: '5%',
            left: '24px',
            height: '25px',
            color: '#051D39',
            fontFamily: theme.typography.fontFamily,
            fontSize: '20px',
            fontWeight: '500',
            letterSpacing: '0',
            lineHeight: '25px',
            userSelect: 'text',
        },
    },
    instagramMedia: {
        background: 'white',
        maxWidth: '540px',
        width: 'calc(100% - 2px)',
        borderRadius: '3px',
        border: '1px solid rgb(219, 219, 219)',
        boxShadow: 'none',
        display: 'block',
        margin: '0px 0px 12px',
        minWidth: '326px',
        padding: '0px',
    },
})
export default styles
